module.exports = __webpack_public_path__ + "img/N121-1.a36276f0.png";